import {Check} from "@sparkware/app-utils";
import {ILazy} from "./lazy.interface";

export class LazyAsync<T> implements ILazy<T> {
    constructor(private _valueFactory: () => Promise<T>) {
    }

    readonly isLazy = true;

    private _promisedValue: Promise<T> = undefined;
    private _resolvedValue: T = undefined;
    private _initializing = false;
    private _initValue(): void {
        if(this._initializing) {
            throw new Error('Lazy circular dependency detected: ' + this._valueFactory)
        }
        if(Check.isUndefined(this._promisedValue)) {
            this._initializing = true;
            try {
                this._promisedValue = this._valueFactory().then(instance => {
                    this._resolvedValue = instance;
                    return this._resolvedValue;
                });
            }
            finally {
                this._initializing = false;
            }

        }
    }

    get value(): Promise<T> {
        this._initValue();
        return this._promisedValue;
    }

    tryGetResolvedValue(): T | Promise<T> {
        if(this._resolvedValue) {
            return this._resolvedValue;
        }
        return this.value;
    }

    forceInit(): void {
        this._initValue();
    }
}
